import { FileText, icons, type LucideIcon } from 'lucide-react';

/** Renders a page icon: emoji, `lucide:<Name>:<color>` or an image URL. Falls back to the default page glyph. */
export function PageIcon({ icon, size = 18, kind = 'page', className }: { icon: string | null | undefined; size?: number; kind?: 'page' | 'database'; className?: string }) {
  const style = { width: size, height: size, fontSize: size * 0.9 };
  if (!icon) {
    return (
      <span className={`lm-page-icon ${className ?? ''}`} style={{ ...style, color: 'var(--lm-color-text-tertiary)' }} data-icon="default" data-kind={kind}>
        <FileText strokeWidth={1.75} />
      </span>
    );
  }
  if (icon.startsWith('lucide:')) {
    const [, name = 'FileText', color = 'default'] = icon.split(':');
    const Cmp = (icons as Record<string, LucideIcon>)[name] ?? FileText;
    const fg = color === 'default' ? 'var(--lm-color-text-secondary)' : `var(--lm-color-block-text-${color})`;
    return (
      <span className={`lm-page-icon ${className ?? ''}`} style={{ ...style, color: fg }} data-icon={icon}>
        <Cmp strokeWidth={2} />
      </span>
    );
  }
  if (/^(https?:|\/|data:)/.test(icon)) {
    return (
      <span className={`lm-page-icon ${className ?? ''}`} style={style} data-icon="image">
        <img src={icon} alt="" />
      </span>
    );
  }
  return (
    <span className={`lm-page-icon ${className ?? ''}`} style={style} data-icon={icon} role="img">
      {icon}
    </span>
  );
}
